import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EMPTY_STAR, FULL_STAR, HALF_STAR, NO_RATING_STAR, QUARTER_STAR, THREE_QUARTER_STAR, TOTAL_STARS } from './Ratings.constants';
/** Round the floating point value to the nearest quarter b/w (0, 0.25, 0.5, 0.75, 1) */
export const roundToNearestQuarter = val => {
  if (val >= 0.875) return 1;else if (val >= 0.625) return 0.75;else if (val >= 0.375) return 0.5;else if (val >= 0.125) return 0.25;
  return 0;
};

/** Rounds the rating to a discrete value */
export const getDiscreteRating = averageStars => {
  const integer = Math.trunc(averageStars);
  const decimal = averageStars % 1;
  return integer + roundToNearestQuarter(decimal);
};
export const FRACTION_TO_STAR_COUNT = {
  0: {},
  0.25: {
    quarterStarsCount: 1
  },
  0.5: {
    halfStarsCount: 1
  },
  0.75: {
    threeQuarterStarsCount: 1
  }
};
export const getStarCounts = averageStars => {
  const discreteRating = getDiscreteRating(averageStars);
  const fullStarsCount = Math.trunc(discreteRating);
  const partiallyFilledStarsCount = Math.ceil(discreteRating % 1);
  const partiallyFilledStars = FRACTION_TO_STAR_COUNT[discreteRating % 1];
  const emptyStarsCount = TOTAL_STARS - fullStarsCount - partiallyFilledStarsCount;
  return _objectSpread({
    fullStarsCount,
    emptyStarsCount
  }, partiallyFilledStars);
};
export const getStarVariations = ratings => {
  if (!ratings.numRatings) {
    return [...new Array(TOTAL_STARS).fill(NO_RATING_STAR)];
  }
  const {
    fullStarsCount = 0,
    quarterStarsCount = 0,
    halfStarsCount = 0,
    threeQuarterStarsCount = 0,
    emptyStarsCount = 0
  } = getStarCounts(ratings.avgStars);
  return [...new Array(fullStarsCount).fill(FULL_STAR), ...new Array(quarterStarsCount).fill(QUARTER_STAR), ...new Array(halfStarsCount).fill(HALF_STAR), ...new Array(threeQuarterStarsCount).fill(THREE_QUARTER_STAR), ...new Array(emptyStarsCount).fill(EMPTY_STAR)];
};

/** Rounds the rating upto one decimal. Eg:- 3.0 -> 3, 3.64 -> 3.6 */
export const roundRatingToOneDecimal = rating => Number(rating.toFixed(1));